import React from 'react';
import styled from 'styled-components';
import { ETheme } from '@datatype/type';
import * as color from '@constant/color';
import * as size from '@constant/size';

type TQuoteSize = 'small' | 'medium' | 'large';

interface IProps {
  children: React.ReactNode;
  theme?: ETheme;
  size?: TQuoteSize;
  width?: string;
  height?: string;
}

const createDesign = (quoteSize: TQuoteSize, theme: ETheme, width?: string, height?: string) => {
  const createSize = () => {
    switch (quoteSize) {
      case 'small':
        return { paddingLeft: size.DESIGN_SYSTEM_BUTTON_SMALL_PADDING_X };
      case 'large':
        return { paddingLeft: size.MARGIN_2 };
      case 'medium':
      default:
        return { paddingLeft: size.MARGIN_1 };
    }
  };
  const createTheme = () => {
    switch (theme) {
      case ETheme.GRAY:
        return { lineColor: color.GRAY_2 };
      case ETheme.BLACK:
        return { lineColor: color.BLACK_2 };
      case ETheme.GREEN:
        return { lineColor: color.GREEN_3 };
      case ETheme.RED:
        return { lineColor: color.RED_3 };
      case ETheme.BLUE:
        return { lineColor: color.BLUE_2 };
      case ETheme.BROWN:
      default:
        return { lineColor: color.BROWN_2 };
    }
  };
  return { ...createSize(), ...createTheme(), width, height };
};

type TDesign = ReturnType<typeof createDesign>;

const Wrapper = styled.div<{ $design: TDesign }>`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: ${({ $design }) => $design.width || 'fit-content'};
  height: ${({ $design }) => $design.height || 'auto'};
  padding-left: ${({ $design }) => $design.paddingLeft};
`;
const QuoteLine = styled.div<{ $design: TDesign }>`
  position: absolute;
  left: 0;
  top: calc(${size.MARGIN_1} / 2);
  bottom: calc(${size.MARGIN_1} / 2);
  width: ${size.BORDER_WIDTH_2};
  background-color: ${({ $design }) => $design.lineColor};
`;

const Quote: React.FC<IProps> = ({ children, theme = ETheme.BROWN, size = 'medium', width, height }) => {
  const design = createDesign(size, theme, width, height);
  return (
    <Wrapper $design={design}>
      <QuoteLine $design={design} />
      {children}
    </Wrapper>
  );
};

export default Quote;
